import { useState } from 'react';
import { useAsyncEffect } from 'ahooks';
import { Result } from 'antd';
import { BootstrapContent } from './bootstrap-content.jsx';
import { Loader } from './compts/loader/loader.jsx';
import { type BootstrapOptions } from './types/layout.js';

export const Bootstrap = (options: BootstrapOptions) => {
  const [renderFlag, setRenderFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  useAsyncEffect(async () => {
    try {
      if (options.getGlobalData) {
        const globalData = await options.getGlobalData();
        if (globalData) {
          window['GLOBAL'] = globalData as any;
        }
      }
      setRenderFlag(true);
    } catch (error) {
      setErrorMessage(error?.['message'] || '获取初始加载数据失败');
    }
  }, []);

  if (errorMessage) {
    return <Result status="error" title={errorMessage} />;
  }

  if (!renderFlag) {
    return <Loader spinning={true} />;
  }

  return <BootstrapContent {...options} />;
};
